<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const materialTypeOptions = [
        `Équipements de soudure`,
        `Matériel électrique & instrumentation`,
        `Pompes et compresseurs`,
        `Tuyauterie & robinetterie`,
        `Manutention & levage`,
        `Équipements de protection (EPI)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const purchaseModeOptions = [`Acheter`, `Louer`, `Les deux, selon le matériel`].map(
        (v) => ({ label: v, value: v, key: v }),
    );

    const volumeUrgencyOptions = [
        `Achat ponctuel (un seul équipement)`,
        `Petit lot (2 à 5 équipements)`,
        `Approvisionnement régulier (consommables, pièces, EPI)`,
        `Projet à grande échelle (chantier, usine, exploitation)`,
        `Besoin urgent (livraison rapide sous 7 jours)`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.materielsIndustriels.materialType}
        class=""
        let:field
        let:id
        label={`Quel type de matériel recherchez-vous ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={materialTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materielsIndustriels.purchaseMode}
        class=""
        let:field
        let:id
        label={`Souhaitez-vous acheter ou louer ce matériel ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={purchaseModeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materielsIndustriels.volumeUrgency}
        class=""
        let:field
        let:id
        label={`Quel est le volume ou l'urgence de votre besoin ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={volumeUrgencyOptions}
            placeholder="Sélectionnez votre besoin"
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
